module.exports = __webpack_public_path__ + "media/country_flags/ye-92a3dd9c.png";